import { tenantsCountriesEnum } from '@/enums/tenantsCountries.enum';

import { TENANT } from './constants';

export const getIsTenantCountry = (tenantCountry: tenantsCountriesEnum) =>
  TENANT.split('-')?.[0] === tenantCountry;
